// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"9f1f84be","362":"e0516316"}[chunkId] + ".chunk.js";
};